import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLIC_KEY as string
);

const apiUrl = process.env.REACT_APP_API_URL;

interface StripeCheckoutProps {
  amount?: number;
  paymentReference?: string;
  clientSecret?: string;
  onSuccess: () => void;
}

export const StripeCheckoutWrapper: React.FC<StripeCheckoutProps> = ({
  amount,
  paymentReference,
  clientSecret: providedClientSecret,
  onSuccess
}) => {
  const stripeE2EBypass = process.env.REACT_APP_STRIPE_E2E_BYPASS;
  const isStripeE2ETesting = stripeE2EBypass
    ? stripeE2EBypass === '1'
    : process.env.REACT_APP_E2E_TESTING === '1';
  const [resolvedClientSecret, setResolvedClientSecret] = useState<string | null>(providedClientSecret ?? null);
  const normalizedAmount = amount ?? 0;

  useEffect(() => {
    if (providedClientSecret) return;
    if (!paymentReference) return;

    const createIntent = async () => {
      const res = await fetch(`${apiUrl}/api/stripe/payment-intent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          amount: normalizedAmount * 100,
          paymentReference
        })
      });

      const data = await res.json();

      setResolvedClientSecret(data.clientSecret);
    };

    createIntent();
  }, [normalizedAmount, paymentReference, providedClientSecret]);

  useEffect(() => {
    if (providedClientSecret) {
      setResolvedClientSecret(providedClientSecret);
    }
  }, [providedClientSecret]);

  if (isStripeE2ETesting) {
    return (
      <div>
        <p>Stripe E2E-läge</p>
        <button type="button" className="submit-button" onClick={onSuccess}>
          E2E slutför Stripe
        </button>
      </div>
    );
  }

  if (!resolvedClientSecret) return <div>Förbereder betalning...</div>;

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret: resolvedClientSecret
      }}
    >
      <StripeCheckoutForm onSuccess={onSuccess} />
    </Elements>
  );
};

const StripeCheckoutForm: React.FC<{ onSuccess: () => void }> = ({
  onSuccess
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    setLoading(true);

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href
      },
      redirect: "if_required"
    });

    if (result.error) {
      console.error(result.error.message);
      setLoading(false);
      return;
    }

    onSuccess();
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />

      <button
        type="submit"
        disabled={!stripe || loading}
        className="submit-button"
      >
        {loading ? "Bearbetar..." : "Betala"}
      </button>
    </form>
  );
};
